<form [formGroup]="matrixFormGroup" *ngIf="matrixFormGroup">
    <a
        href="javascript:void(0)"
        *ngIf="isAddToMatrix"
        (click)="open(mymodal1)"
        class="btn primary-ebtn font-weight-bold py-3 px-6 me-3"
        [ngClass]="{ disable: !calcOutput }"
    >
        {{ 'INFORMATE_HEADER.BUTTONS_TEXT.ADD_TO_MATRIX' | transloco }}
    </a>
    <ng-template #mymodal1 let-modal>
        <div class="modal-header">
            <h4>Joint Matrix</h4>
            <a class="close-icon" href="javascript:void()" ngbAutofocus (click)="modal.close('Ok click')">
                <i class="flaticon2-cross"></i>
            </a>
        </div>
        <div class="modal-body output-lable">
            <app-matrix-name [form]="matrixFormGroup"></app-matrix-name>
            <div class="pt-3">
                <app-matrix-joint-id [form]="matrixFormGroup"></app-matrix-joint-id>
            </div>
        </div>
        <div class="modal-footer">
            <button type="submit" class="btn primary-ebtn" (click)="btnAddMatrixClicked()">{{ 'SETTING_PAGE.IDMS_SETTINGS.ADD' | transloco }}</button>
            <button type="button" class="btn secondary-ebtn" (click)="modal.close('Ok click')">{{ 'SETTING_PAGE.IDMS_SETTINGS.CANCEL' | transloco }}</button>
        </div>
    </ng-template>
</form>
